// Auth
export const SET_AUTH = 'SET_AUTH';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const SEND_LOGIN_DETAILS_SUCCESS = 'SEND_LOGIN_DETAILS_SUCCESS';
export const SEND_LOGIN_DETAILS_FAIL = 'SEND_LOGIN_DETAILS_FAIL';